import { render, staticRenderFns } from "./StatisticCardCustom.vue?vue&type=template&id=befe9da0&scoped=true&"
import script from "./StatisticCardCustom.vue?vue&type=script&lang=js&"
export * from "./StatisticCardCustom.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCardCustom.vue?vue&type=style&index=0&id=befe9da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe9da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VIcon})
